import { DefaultService } from "@/services/DefaultService";
import API from "@/plugins/axios";

class ViewPDFService extends DefaultService {
    constructor() {
        super('');
    }
    viewPDF(url: any, data: any, type: any, name: string, headers: any = {}): Promise<any>{
        return API.request({
            url: url,
            data: data,
            method: type,
            responseType: 'blob',
            headers: headers
        });
    }

    getDataEstablecimiento(id: any): Promise<any>{
        return API.get(`establecimientos/getDataEstablecimiento/${id}`);
    }
    
    getDataEstablecimientoExtemporaneo(id: any): Promise<any>{
        return API.get(`establecimientos/getDataExtemporaneo/${id}`);
    }

    getDataCesionDerecho(id: any): Promise<any>{
        return API.get(`establecimientos/getDataCesionDerecho/${id}`);
    }
    
    getDataArrendamiento(id: any): Promise<any>{
        return API.get(`establecimientos/getDataArrendamiento/${id}`);
    }
    
    getDataEstablecimientoMercado(id: any): Promise<any>{
        return API.get(`establecimientos/getDataMercado/${id}`);
    }
    
    getDataEstablecimientoLicenciaAlcohol(licencia_id: any, id: any): Promise<any>{
        return API.get(`licencia/${licencia_id}/getEdoCuentaAlcohol/${id}`);
    }
    
    getDataEstablecimientoHorariosExtra(licencia_id: any, id: any): Promise<any>{
        return API.get(`licencia/${licencia_id}/getEdoCuentaFiscalizacion/${id}`);
    }
    
    getDataEstablecimientoConstanciaSuelo(id: any): Promise<any>{
        return API.get(`constancia_uso_suelo/${id}/getEdoCuentaConstanciaSuelo`);
    }
    
    getDataEstablecimientoAnuncio(id: any): Promise<any>{
        return API.get(`anuncio/${id}/getEdoCuentaAnuncio`);
    }
    
    getDataEstablecimientoAnuncioExterno(id: any): Promise<any>{
        return API.get(`anuncioexterno/${id}/getEdoCuentaAnuncio`);
    }
    
    getFolioPago(data: any): Promise<any>{
        return API.post(`pagosopb/getFolio`, data);
    }
}

export default new ViewPDFService;